import * as React from 'react';

import classnames from 'classnames';

import {Card} from 'shells/card/card';
import {CTABanner} from 'shells/cta-banner/cta-banner';
// @ts-expect-error - imported from .js/.jsx file
import {ReportsIcon} from 'shells/icon/svg/reports-icon';
import NutshellLogo from 'shells/logos/nutshell-logo.svg';
import WebFXLogo from 'shells/logos/webfx-logo.svg';
import {MarketingBody} from 'shells/typography/marketing-body';
import {MarketingHeader} from 'shells/typography/marketing-header';

import {analyticsClient} from '../../../analytics-client';

import styles from './competitors.module.css';

export function ChartPageBanner() {
    return (
        <div>
            {/* This is visible in the UI, removed for the downloaded report */}
            <div className={classnames('report-chart-ui-header', styles['report-chart-ui-header'])}>
                <CTABanner
                    icon={ReportsIcon}
                    title='Generate more traffic and leads from your website'
                    text='Review your strategy with one of our marketing experts'
                    buttonText='Schedule a call'
                    href='https://www.nutshell.com/marketing-services/email-marketing-services'
                    newTab={true}
                    onPrimaryAction={() => {
                        analyticsClient.track(
                            analyticsClient.EVENTS.TRACK_COMPETITOR_IQ_MARKETING_LINK_CLICKED
                        );
                    }}
                />
            </div>
            {/* This is not visible in the UI, only used for the downloaded report */}
            <div className={classnames('download-chart-header', styles['download-chart-header'])}>
                <Card hasBorder={true}>
                    <div className='pad-16'>
                        <MarketingHeader>
                            This CompetitorSpy report is powered by Nutshell & WebFX.{' '}
                        </MarketingHeader>
                        <MarketingBody>
                            Get a free marketing audit and learn how to increase organic and paid
                            traffic to your website.
                        </MarketingBody>
                        <div className={styles['logo-container']}>
                            <NutshellLogo width={226} height={90} />
                            <WebFXLogo width={143} height={100} />
                        </div>
                    </div>
                </Card>
            </div>
        </div>
    );
}
